import * as requests from "../../coraWebComponents/utils/requests";
import urls from "../../constants/Urls";

const buildDodavatel = (id = "") => {
  return `${urls.Dodavatel}/${id}`;
};

export const getDodavatel = async (id) => {
  if (id === 0) {
    return null;
  }

  const url = buildDodavatel(id);
  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getDodavatelCurrentUser = async () => {
  const url = `${buildDodavatel()}currentUser`;

  try {
    let res = await requests.get(url);
    return res;
  } catch (error) {
    throw error;
  }
};

export const getListDodavatel = async (filter, sort, page) => {
  const url = buildDodavatel();

  try {
    let res = await requests.getList(url, filter, sort, page);
    return res;
  } catch (error) {
    throw error;
  }
};
